export default __webpack_public_path__ + "static/media/svenskaspel.3c9ff54b.jpeg";